
//存储mutation相关的状态常量
export const SET_PHONE = 'SET_PHONE'

export const SET_USER_ID = 'SET_USER_ID'

export const SET_USERNAME = 'SET_USERNAME'

export const SET_AVATAR_URL = 'SET_AVATAR_URL'

export const SET_IS_LOGIN = 'SET_IS_LOGIN'

export const SET_VIDEO_ID = 'SET_VIDEO_ID'

export const SET_SONGLIST_ID = 'SET_SONGLIST_ID'

export const SET_RADIO_ID = 'SET_RADIO_ID'

export const SET_COMMENT_TYPE = 'SET_COMMENT_TYPE'

export const SET_OTHER_USER_ID = 'SET_OTHER_USER_ID'

export const SET_SINGER_ID = 'SET_SINGER_ID'

export const SET_PLAYING_STATE = 'SET_PLAYING_STATE'

export const SET_FULL_SCREEN = 'SET_FULL_SCREEN'

export const SET_PLAYLIST = 'SET_PLAYLIST'

export const SET_SEQUENCE_LIST = 'SET_SEQUENCE_LIST'

export const SET_PLAY_MODE = 'SET_PLAY_MODE'

export const SET_CURRENT_INDEX = 'SET_CURRENT_INDEX'

export const SET_DISC = 'SET_DISC'

export const SET_TOP_LIST = 'SET_TOP_LIST'

export const SET_MODE_TYPE = 'SET_MODE_TYPE'

export const SET_SEARCH_HISTORY = 'SET_SEARCH_HISTORY'

export const SET_PLAY_HISTORY = 'SET_PLAY_HISTORY'

export const SET_FAVORITE_LIST = 'SET_FAVORITE_LIST'

export const SET_IS_TOP = 'SET_IS_TOP'

export const SET_TOKEN = 'SET_TOKEN'
